// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2l_2S","log":"ModalInventoryLogs_log__2Eacc","date":"ModalInventoryLogs_date__VXkIc","userName":"ModalInventoryLogs_userName__3fXnX"};